var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightRound = function SvgArrowRightRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 41"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.416,
    cy: 20.536,
    r: 19.008,
    stroke: "#000",
    strokeWidth: 1.462
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.242,
    d: "M9.328 20.836h19.865m0 0-8.07-8.07m8.07 8.07-8.07 8.07"
  })));
};
export default SvgArrowRightRound;